export default function Cursor() {
    return (
     <>
      {/* <!-- Cursor Animation --> */}
        <div className="cursor1"></div>
        <div className="cursor2"></div>

        {/* <!-- Scroll Smoother --> */}
            {/* <div className="has-smooth" id="has_smooth"></div> */}

        {/* <!-- Go Top Button --> */}
            <button id="scroll_top" className="scroll-top"><i className="fa-solid fa-arrow-up"></i></button>
     </>
     )
    }
    